<template>
  <div class="company-services">
    <div class="company-services-title">
      {{ $t('sp.registration.company.services.title') }}
    </div>
    <company-services-form
      :value="spFreelancerServicesInfo"
      @changed="formChanged"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CompanyServicesForm from '@/components/spFreelancerRegistration/CompanyServicesForm.vue';
import { CHANGE_SP_FREELANCER_SERVICES_INFO } from '@/store/spFreelancerRegistration/actionTypes';

export default {
  name: 'CompanyServices',
  components: {
    CompanyServicesForm,
  },
  computed: {
    ...mapGetters([
      'spFreelancerServicesInfo',
    ]),
  },
  methods: {
    formChanged(data) {
      this.$store.dispatch(CHANGE_SP_FREELANCER_SERVICES_INFO, data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.company-services {
  border-radius: $radius-sm;
  background-color: $white;
  padding: rem(50) rem(80) rem(35);
  box-shadow: 0 0 rem(4) 0 rgba(14, 31, 51, 0.13);
  flex: 0.7;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.company-services-title {
  color: $auth-text-primary;
  font-family: $font-family-medium;
  font-size: rem(20);
  font-weight: 500;
  letter-spacing: 0;
  line-height: rem(24);
  padding-bottom: rem(5);
}
</style>
